import { cn } from "@/lib/utils";
import { Plus, Image as ImageIcon } from "lucide-react";

interface MultiColumnViewProps {
    settings: any;
    columnsCount: number;
    renderElement: (element: any) => React.ReactNode;
}

export const MultiColumnView = ({
    settings,
    columnsCount,
    renderElement
}: MultiColumnViewProps) => {
    const columns = settings.columns || Array(columnsCount).fill({ content: "empty" });
    const gap = settings.gap || "16";
    const padding = settings.padding || "16";
    const background = settings.background || "transparent";

    return (
        <div
            className="w-full"
            style={{
                padding: `${padding}px`,
                background,
                gap: `${gap}px`,
            }}
        >
            <div
                className="grid w-full"
                style={{
                    gridTemplateColumns: columns.map((col: any) => col.width ? `${col.width}%` : '1fr').join(' '),
                    gap: `${gap}px`,
                }}
            >
                {columns.map((column: any, index: number) => (
                    <div
                        key={index}
                        className="relative min-h-[50px]"
                    >
                        {/* Column Content */}
                        {column.elements && column.elements.length > 0 ? (
                            column.elements.map((element: any) => (
                                <div key={element.id} className="mb-4 last:mb-0">
                                    {renderElement(element)}
                                </div>
                            ))
                        ) : (
                            // Empty state or legacy content
                            <div className="flex flex-col items-center justify-center h-full text-center">
                                {column.content === "text" ? (
                                    <div className="text-gray-600 text-sm p-4">
                                        {column.text || ""}
                                    </div>
                                ) : column.content === "image" ? (
                                    column.imageUrl ? (
                                        <img
                                            src={column.imageUrl}
                                            alt={`Column ${index + 1}`}
                                            className="w-full h-auto object-cover rounded"
                                        />
                                    ) : null
                                ) : null}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
